import http from "@/utils/request"

export default {
	trade: {
		overview: async function () {
			return await http.get("trade/overview");
		},
		merchantRank: async function () {
			return await http.get("trade/merchant/rank");
		},
		trend: async function () {
			return await http.get("trade/trend");
		},
		distribution: async function () {
			return await http.get("trade/distribution");
		},
	},
	merchant: {
		overview: async function () {
			return await http.get("merchant/overview");
		},
	},
}
